import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

function AdminNavBar() {

    useEffect(() => {
    }, [])

    return (
        <nav className="navbar navbar-expand-lg " color-on-scroll="500">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/admin">Dashboard </Link>
                <div className="collapse navbar-collapse justify-content-end" id="navigation">
                </div>
            </div>
        </nav>
    )
}

export { AdminNavBar }